<template>
  <div class="" v-if="$route.meta.showHeader">
    <div class="po-f w100 header">
      <div class="po-a w100 h100 header-bg-jyb" v-if="theme === 'theme-w' && showHeadImg()"></div>
      <div class="po-a w100 h100 header-bg" :style="`opacity: ${headTop}`" v-else></div>
      <div class="flex-box al-c pl20 pr20 header-main po-r">
        <router-link class="mr20 header-logo" to="/" style="display: flex;align-items: center;justify-content: space-around">
           <img :src="logoImg" style="margin-right: 20px;width: 464px;height: 69px;">
        </router-link>
        <div style="font-size:24px;display:inline-block">{{logoText}}</div>
        <div class="flex-1 flex-box al-c ju-c">
          <router-link
            class="link-item flex-box head-a"
            to="/office"
            :class="$route.name == '/office' ? 'router-link-active' : null"
            v-if="hasItem('/office')"
            >
            <img :src="`${baseUrl}images/dl-02.png`" class="head-img">
            首页</router-link
          >
          <router-link
            class="link-item flex-box head-a"
            to="/accrualBasis"
            :class="$route.name == '/accrualBasis' ? 'router-link-active' : null"
            v-if="hasItem('/accrualBasis')"
            >
            <img :src="`${baseUrl}images/dl-01.png`" class="head-img">
            权责清单</router-link
          >
          <router-link
            class="link-item flex-box head-a"
            to="/serveCenter"
            :class="$route.name == '/serveCenter' ? 'router-link-active' : null"
            v-if="hasItem('/serveCenter')"
            >
            <img :src="`${baseUrl}images/dl-03.png`" class="head-img">
            办事大厅</router-link
          >
          <router-link
            class="link-item flex-box head-a"
            to="/statistical/all"
            :class="$route.name == '/statistical' ? 'router-link-active' : null"
            v-if="hasItem('/statistical')"
            >
            <img :src="`${baseUrl}images/dl-05.png`" class="head-img">
            效能督办</router-link
          >
          <!--<router-link class="link-item flex-box" to="/mine" :class="$route.name == '/mine' ? 'router-link-active' : null" v-if="hasItem('/mine')">个人中心</router-link>-->
          <router-link
            class="link-item flex-box head-a"
            to="/management/user"
            :class="$route.name == '/offmanagementice' ? 'router-link-active' : null"
            v-if="hasItem('/management')"
            >
            <img :src="`${baseUrl}images/dl-04.png`" class="head-img">
            管理中心</router-link
          >
        </div>
        <div class="ml20 flex-box al-c font-24">
          <el-badge v-if="unReadMsgCount > 0" is-dot class="item">
            <img
              class="msg-log"
              :src="`${baseUrl}images/${theme}-msg.svg`"
              @click="$router.push({ path: '/mine/message' })"
            />
          </el-badge>
          <img
            v-else
            class="msg-log"
            :src="`${baseUrl}images/${theme}-msg.svg`"
            @click="$router.push({ path: '/mine/message' })"
          />
        </div>
        <div class="ml20 flex-box al-c font-14" v-if="userData">
          <!--<i class="el-icon-s-comment cu-p font-24" @click="goPage('/mine/message')"></i>-->
          <el-dropdown>
            <div class="flex-box al-c pl10 ml10 " id="header-dropdown">
              <img v-if="userData.userImage" :src="userData.userImage" width="24" height="24" />
              <i v-else class="el-icon-s-custom font-24"></i>
              <span class="ml5">{{ userData.name }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="hasItem('/mine')">
                <router-link class="w100 in-block" to="/mine/userData">个人中心</router-link>
              </el-dropdown-item>

              <el-dropdown-item @click.native="displaySetting">
                <span>我的展示方案</span>
              </el-dropdown-item>

              <el-dropdown-item divided @click.native="goOut()">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <router-link
          v-else
          class="ml20 font-16 cu-p white pt5 pb5 pl20 pr20 bor"
          style="border-radius: 4px;"
          to="/login"
          >登录</router-link
        >
      </div>
    </div>
    <div class="w100" style="height: 70px;"></div>
    <AddComplain ref="addComplain" />

    <a class="none" ref="download" :href="href" target="_black"></a>

    <el-dialog
      v-if="showcaseConfig"
      class="selfModal"
      :close-on-click-modal="false"
      :visible.sync="showcaseConfig"
      :title="showcaseConfigData.deskName"
      width="1330px"
      top="20px"
      :before-close="closeShowcaseDialog"
    >
      <ShowcaseConfig
        ref="showcaseConfig"
        :showcaseConfigData="showcaseConfigData"
        @closeShowcaseConfig="closeShowcaseConfig"
      />
    </el-dialog>

    <el-dialog v-if="settingDialog" :close-on-click-modal="false" :visible.sync="settingDialog" width="600px">
      <div class="flex-box">
        <div class="w50">
          <el-link type="primary" @click="goUserShowcase">自定义我的展示方案</el-link>
        </div>
        <div class="w50">
          <el-dropdown>
            <span>
              <i class="el-icon-menu el-icon--left"></i>
              {{ themeName }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="themeClick('theme-w')">
                <div class="flex-box al-c ">
                  <div style="background-color:#fff" class="bor theme-item"></div>
                  <div class="ml10">简约白</div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item @click.native="themeClick('theme-qxl')">
                <div class="flex-box al-c ">
                  <div style="background-color:#598FE0" class="theme-item"></div>
                  <div class="ml10">清新蓝</div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item @click.native="themeClick('theme-swl')">
                <div class="flex-box al-c ">
                  <div style="background-color:#064576" class="theme-item"></div>
                  <div class="ml10">商务蓝</div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item @click.native="themeClick('theme-dlz')">
                <div class="flex-box al-c ">
                  <div style="background-color:#cf5d15" class="theme-item"></div>
                  <div class="ml10">活力橙</div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="settingDialog = false">确 认</el-button>
        <el-button style="margin-left: 8px" size="small" @click="settingDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AddComplain from "@/components/management/complain/AddComplain";
import ShowcaseConfig from "@/views/management/showcase/showcaseConfig";
import config from "./../../../public/config";
import { maiyuessoLogoutUrl,getLoginConfig } from "@/api/login";
export default {
  name: "Header",
  components: {
    AddComplain,
    ShowcaseConfig
  },
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      href: "",
      fileName: "",
      logoText: "",
      logoImg:'',
      headTop: 1,
      headTopSwitch: null,

      showcaseConfigData: {
        deskId: "",
        deskName: "",
        deskType: ""
      },
      showcaseConfig: false,
      settingDialog: false,
      themeName: "",
      pathArr: ["/noticesAndFilesPagination", "/office", "/accrualBasis", "/serveCenter", "/statistical/all"]
    };
  },
  computed: {
    ...mapGetters(["userData", "userToken", "theme", "unReadMsgCount"])
  },
  created() {},
  mounted() {
    getLoginConfig().then(res => {
      if (res.data.success) {
        this.logoText = res.data.data.logo_text;
        this.logoImg = res.data.data.logo;
        res.data.data.isOpenCassso == "1"
          ? (res.data.data.isOpenCassso = true)
          : (res.data.data.isOpenCassso = false);
        res.data.data.middlePage == "1"
          ? (res.data.data.middlePage = true)
          : (res.data.data.middlePage = false);
        res.data.data.phone == "1"
          ? (res.data.data.phone = true)
          : (res.data.data.phone = false);
        res.data.data.mobileOrPc == "1"
          ? (res.data.data.mobileOrPc = true)
          : (res.data.data.mobileOrPc = false);
        window.sessionStorage.setItem(
          "setConfig",
          JSON.stringify(res.data.data)
        );
        let faviconLink = document.querySelector("#faviconLink");
        if (faviconLink) {
          faviconLink.setAttribute("href", res.data.data.favicon);
        }
      }
    });
    this.themeNameHandler();
  },
  destroyed() {},
  methods: {
    ...mapActions(["logout", "changeTheme", "GetUnreadCount"]),
    hasItem(str) {
      if (this.userData && this.userData.routerData && this.userData.routerData.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    isAdmin() {
      return (this.userData.roleCodes || []).includes("ROLE_ADMIN");
    },
    goPage(path) {
      this.$router.push(path);
    },
    closeShowcaseDialog() {
      this.$refs.showcaseConfig.closeShowcaseConfig();
    },
    closeShowcaseConfig() {
      this.showcaseConfig = false;
    },
    storageClear() {
      localStorage.removeItem("userData");
      localStorage.removeItem("token");
      sessionStorage.removeItem("vuex");
      sessionStorage.removeItem("nz_access_token");
      sessionStorage.removeItem("setConfig");
      sessionStorage.removeItem("userData");
      sessionStorage.removeItem("loginSsoCode");
    },
    // 退出
    goOut() {
      // window.sessionStorage.clear();
      // window.localStorage.clear();
      // this.storageClear()
      // window.location.reload()
      //是否配置地址（金融职院 需要  其他则注销）
      // if(config.defaultUrl!=""){
      //   window.open(config.defaultUrl,"_self")
      // }else{
        //浏览器唯一账号登录
      // localStorage.removeItem("userData");
      //   this.goPage("/login");
      // }
      let config = JSON.parse(window.sessionStorage.getItem('setConfig'))
      if(config.isOpenCassso){
        this.logout();
        this.storageClear();
        this.getUrl();
      }else{
        this.logout();
        this.storageClear();
        this.goPage("/login");
      }
      
    },
    // 添加投诉
    addCom() {
      this.$refs.addComplain.dialogShow();
    },
    downloadHelp() {
      this.$http
        .get("/bigFile/getUrl/useHelp", {
          params: {
            token: this.userToken
          }
        })
        .then(({ data }) => {
          // console.log(data);
          if (data.resCode == 0) {
            this.href = this.$http.defaults.baseURL + data.resData + "?token=" + this.userToken;

            this.$nextTick(() => {
              this.$refs.download.click();
            });
          }
        })
        .catch(() => {
          this.$message.error("获取下载连接失败，请检查网络");
        });
    },
    // 滚动监听头部颜色渐变
    onScroll() {
      window.addEventListener("scroll", this.handleScroll);
    },
    removeScroll() {
      window.removeEventListener("scroll", this.handleScroll);
    },
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

      if (scrollTop < 200) {
        this.headTop = scrollTop / 200;
      } else {
        this.headTop = 1;
      }
    },
    displaySetting() {
      console.log("?");
      this.settingDialog = true;
    },
    themeClick(themeName) {
      this.changeTheme(themeName);
      localStorage.setItem("themeName", themeName);
    },
    goUserShowcase() {
      this.$store
        .dispatch("getPageDeskVo")
        .then(() => {
          this.showcaseConfigData.deskName = JSON.parse(localStorage.getItem("userData")).userName + "的桌面";
          this.showcaseConfigData.deskType = "user";
          this.showcaseConfig = true;
        })
        .catch(msg => {
          this.$message.error(msg);
        });
    },
    themeNameHandler() {
      switch (this.theme) {
        case "theme-w":
          this.themeName = "简约白";
          break;
        case "theme-qxl":
          this.themeName = "清新蓝";
          break;
        case "theme-swl":
          this.themeName = "商务蓝";
          break;
        default:
          this.themeName = "选择皮肤";
          break;
      }
    },
    showHeadImg() {
      const routeName = this.$route.name;
      return (
        routeName.includes("/management") || routeName.includes("/mine") || routeName.includes("/ServeCenterDetail")
      );
    },
    //没有code 获取地址
    getUrl() {
      maiyuessoLogoutUrl().then(res => {
        if (res.data.success) {
          window.open(res.data.data, "_self");
        }
      });
    },
  },
  watch: {
    $route(value) {
      if (!value.meta.noLogin) {
        this.GetUnreadCount();
      }
      if (this.pathArr.includes(value.name)) {
        this.onScroll();
        this.headTop = 0;
      } else {
        this.removeScroll();
        this.headTop = 1;
      }
    },
    theme(val) {
      this.themeNameHandler();
    }
  },
  filters: {}
};
</script>

<style scoped lang="less">
.theme-item {
  height: 18px;
  width: 18px;
  box-sizing: border-box;
}
.bor {
  border: 1px solid #999;
}
.msg-log {
  width: 20px;
  cursor: pointer;
}
/deep/.el-badge__content {
  border: none !important;
}
.head-a {
  display: flex;
  align-items: center;
  .head-img{
    width: 14px;
    height: 14px;
    margin-right: 5px;
  }
}

</style>
